// 组件全局注册
import Vue from 'vue'

import UmfNav from './umfNav'
import UmfButton from './UmfButton'

// 组件库
const Components = [UmfNav, UmfButton]

// 注册全局组件
Components.map(com => {
  Vue.component(com.name, com)
})

export default Vue